import { DataEntry } from "./DataEntry";

export class VehicleDE extends DataEntry {
  noOfVehicles: number;
  modeOfDE: string;
  value: any;
  modeofDEID: number;
  vehicleTypeID: number;
  avgPeoplePerTrip: string;
  totalnoOftripsPerVehicle: string;
  chargingPerc: string;

}